import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingActions from "./FloatingActions";

export default function PublicLayout({ children }) {
  return (
    <div className="grain min-h-screen bg-[#0A0A0A]">
      <Navbar />
      <main className="relative z-10">{children}</main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
